import { render, staticRenderFns } from "./DateInputComponent.vue?vue&type=template&id=46c22705"
import script from "./DateInputComponent.vue?vue&type=script&lang=js"
export * from "./DateInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports